<template>
    <div class="Administration">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;" class="demo-ruleForm">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="开始时间" prop="startTime">
                        <el-date-picker @change="startTime1" v-model="ruleForm.startTime" align="right" type="date"
                            placeholder="选择开始时间" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="结束时间" prop="endTime">
                        <el-date-picker @change="endTime1" v-model="ruleForm.endTime" align="right" type="date"
                            placeholder="选择结束时间" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="店铺" prop="sellerId">
                        <el-select v-model="ruleForm.sellerId" placeholder="请选择店铺" clearable filterable
                            @change="changeSelect" value-key="sellerId">
                            <el-option v-for="item in shop_stationList" :key="item.id" :label="item.shop_name"
                                :value="item.sellerId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="类型" prop="searchType">
                        <el-select v-model="ruleForm.searchType" placeholder="请选择类型" clearable filterable
                            @change="changeInfoKey" value-key="searchType">
                            <el-option v-for="item in infoListKey" :key="item.name" :label="item.name"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
                <el-col :span="8">
                    <el-form-item label="内容" prop="searchStr">
                        <el-select v-model="ruleForm.searchStr" placeholder="请选择内容" clearable filterable
                            value-key="searchStr" style="width: 1300px;">
                            <el-option v-for="item in infoListInfo" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item prop="searchInput">
                        <el-button type="primary" @click="getCreditCardIncomeList()">搜索</el-button>
                        <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row>
            <el-table :data="tableData" v-loading="load_data" :header-cell-style="headClass" border style="width: 100%"
                class="table-container">
                <el-table-column prop="shopName" label="店铺名称" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.shopName }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="marketplaceName" label="市场名称" align="center"></el-table-column>
                <el-table-column prop="orderId" label="订单Id" align="center"></el-table-column>
                <el-table-column prop="transactionType" label="交易类型" align="center"></el-table-column>
                <el-table-column prop="amountType" label="金额类型" align="center"></el-table-column>
                <el-table-column prop="amountDescription" label="金额描述" align="center"></el-table-column>
                <el-table-column label="金额 - (币种)" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.amount }} - ({{ scope.row.currency }})
                    </template>
                </el-table-column>
                <el-table-column prop="quantityPurchased" width="90" label="购买数量" align="center"></el-table-column>
                <el-table-column prop="postedDateTime" label="发布时间" align="center"></el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="[20, 50, 100, 200]" :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "Detailed",
    data() {
        return {
            headClass: this.common.headClass,
            load_data: false,
            tableData: [],
            ruleForm: {
                sellerId: '',
                startTime: '',
                endTime: '',
                searchStr: '',
                searchType: ''
            },
            shop_stationList: [],
            UserInfo: {},
            page: 1,
            size: 20,
            total: 0,
            shopIds: [],
            // 类型列表
            infoList: null,
            infoListKey: null,
            infoListInfo: null,
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.$nextTick(() => {
            this.getInfoList()
            this.getAllSellerAndCountry();
            this.getCreditCardIncomeList();
        })
    },
    methods: {
        // 获取类型列表
        getInfoList() {
            ajaxPost(Baseurl + "amazonOrderSettlement/getTransactionTypes").then(res => {
                if (res.data.code == 200) {
                    this.infoList = res.data.data
                    const keyTranslationMap = {
                        amount_description: "金额描述",
                        amount_type: "金额类型",
                        transaction_type: "交易类型"
                    };
                    const originalKeys = Object.keys(this.infoList);
                    this.infoListKey = originalKeys.map((key) => {
                        const translatedKey = keyTranslationMap[key] || key;
                        return {
                            name: translatedKey,
                            value: key
                        };
                    });
                }
            });
        },
        getCreditCardIncomeList() {
            var parameter = {
                page: this.page,
                size: this.size,
                startTime: this.ruleForm.startTime,
                endtime: this.ruleForm.endTime,
                searchStr: this.ruleForm.searchStr,
                sellerId: this.ruleForm.sellerId,
                searchType: this.ruleForm.searchType
            };
            this.load_data = true;
            ajaxPost(Baseurl + "amazonOrderSettlement/selectAmazonOrderSettlementDetailPage", parameter).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.tableData = data.list;
                    this.total = data.total;
                    this.load_data = false;
                }
            });
        },
        async getAllSellerAndCountry() {
            const API = Baseurl + "sellerController/selectSpSellerByCompanyId";
            const { company_id } = this.UserInfo;
            const paramsData = { company_id: company_id };
            const {
                data: { code, data },
            } = await ajaxPost(API, paramsData);
            if (code === 200) {
                this.shop_stationList = data;
                if (this.shop_stationList.length) {
                    this.shopIds = this.shop_stationList.map(item => item.sellerId)
                    this.getCreditCardIncomeList();
                }
            }
        },
        startTime1(val) {
            const d = new Date(val);
            if (isNaN(d.getTime())) {
                console.error('日期错误!', val);
                return;
            }
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const date = String(d.getDate()).padStart(2, '0');
            const datetime = `${year}-${month}-${date} 00:00:00`;
            this.ruleForm.startTime = datetime;
        },
        endTime1(val) {
            const d = new Date(val);
            if (isNaN(d.getTime())) {
                console.error('日期错误!', val);
                return;
            }
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const date = String(d.getDate()).padStart(2, '0');
            const datetime = `${year}-${month}-${date} 23:59:59`;
            this.ruleForm.endTime = datetime;
        },
        resetFprm(formName) {
            this.$refs[formName].resetFields();
            this.shopIds = this.shop_stationList.map(item => item.sellerId)
            this.getCreditCardIncomeList();
        },
        handleSizeChange(val) {
            this.size = val
            this.getCreditCardIncomeList();
        },
        handleCurrentChange(val) {
            this.page = val
            this.getCreditCardIncomeList();
        },
        changeInfoKey(item) {
            this.infoListInfo = this.infoList[item]
        },
        changeSelect(item) {
            this.shopIds = [item.sellerId]
        }
    },
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-collapse {
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
    }

    .el-collapse-item__header {
        border-bottom: 1px solid #fff;
    }

    .el-collapse-item__wrap {
        border-bottom: 1px solid #fff;
    }

    .el-collapse-item__content {
        padding-bottom: 0px;
    }
}

.line-height {
    line-height: 30px;
}

.line-height4 {
    line-height: 40px;
}

.Detailedspan {
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 4px;
    cursor: pointer;
}

.active {
    background-color: rgb(43, 110, 236);
    color: #fff;
}

.Administration {
    padding-bottom: 72px;
}

.pagination-container {
    width: 100%;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;

    .el-pagination {
        display: flex;
        justify-content: center;
    }
}

.table-container {
    margin-bottom: 20px;
    /* 根据分页组件的高度调整这个值 */
}
</style>